import React from "react";
import { connect } from "react-redux";
import { updateContentFeed } from "signoxe/actions";

class Widget extends React.PureComponent {
  getOrientation() {
    const profile = this.props.profile;
    // console.log("Get Orientation func ", profile, this.props.feed);
    if (
      profile &&
      profile.features &&
      profile.features.multiregion &&
      localStorage.getItem("multiregion_switch") == "true"
    ) {
      return this.props.feed.channel_details.aspect_ratio;
    }

    return this.props.feed.orientation;
  }

  render() {
    const props = this.props;
    const profile = props.profile;
    const multiRegionEnabled =
      profile &&
      profile.features &&
      profile.features.multiregion &&
      localStorage.getItem("multiregion_switch") == "true";
    return (
      <select
        name="orientation_select"
        id="orientation_select"
        title="Select an orientation"
        value={this.getOrientation()}
        onChange={(e) => {
          this.props.setOrientation(e.currentTarget.value);
        }}
        disabled={multiRegionEnabled}
      >
        <option value="LANDSCAPE">Landscape</option>
        <option value="REVERSE_LANDSCAPE">Landscape Reversed</option>
        <option value="PORTRAIT">Portrait</option>
        <option value="REVERSE_PORTRAIT">Portrait Reversed</option>
      </select>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setOrientation: (value) =>
      dispatch(updateContentFeed(ownProps.feed.id, { aspect_ratio: value })),
  };
};

export const OrientationSelectWidget = connect(
  mapStateToProps,
  mapDispatchToProps
)(Widget);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/OrientationSelectWidget/index.js